import Vue from 'vue'

import uiToggleSwitcher from './src/ui-toggle-switcher.vue';

Vue.component('ui-toggle-switcher', uiToggleSwitcher);

export default uiToggleSwitcher;



//////////////////
// WEBPACK FOOTER
// ./~/ui-toggle-switcher/index.js
// module id = 565
// module chunks = 0